document.addEventListener("DOMContentLoaded", function () {
  console.log("infrustructure init");
  const container = document.querySelector(".infrastructure__table");
  if (!container) return;

  // Функция переключения контента
  function switchContent(sectionName) {
    // Проверяем, не активен ли уже этот блок
    const currentActive = document.querySelector(
      ".infrastructure__col-content--active"
    );

    // Проверка активности через классы
    const isAlreadyActive = Array.from(
      document.querySelectorAll(".infrastructure__wrapper")
    ).some(
      (wrapper) =>
        wrapper.classList.contains("infrastructure__wrapper--active") &&
        wrapper.classList.contains(`infrastructure-content-${sectionName}`)
    );

    if (isAlreadyActive) return;

    // Скрыть все блоки контента
    document.querySelectorAll(".infrastructure__wrapper").forEach((content) => {
      content.classList.remove("infrastructure__wrapper--active");
    });

    // Показать ВСЕ целевые блоки с классом
    document
      .querySelectorAll(`.infrastructure-content-${sectionName}`)
      .forEach((target) => {
        target.classList.add("infrastructure__wrapper--active");
      });

    // Обновить активные кнопки только в десктопной версии
    document
      .querySelectorAll(".infrastructure__filter-button")
      .forEach((btn) => {
        btn.classList.remove("infrastructure__filter-button--active");
      });

    // Активировать ВСЕ десктопные кнопки с этим классом
    document
      .querySelectorAll(
        `.infrastructure__filter-button.infrastructure-content-${sectionName}`
      )
      .forEach((btn) => {
        btn.classList.add("infrastructure__filter-button--active");
      });

    // Обновить мобильный селект
    const sourceBtn = document.querySelector(
      `.infrastructure__select-list .infrastructure-content-${sectionName}`
    );
    if (sourceBtn) {
      const selectValue = document.querySelector(
        ".infrastructure__select-value"
      );
      const newButton = sourceBtn.cloneNode(true);
      const oldButton = selectValue.querySelector(
        ".infrastructure__select-button"
      );
      console.log("switch content");
      console.log(oldButton);
      console.log(newButton);
      // Удаляем активный класс если он был
      newButton.classList.remove("infrastructure__filter-button--active");

      if (oldButton) {
        selectValue.replaceChild(newButton, oldButton);
      }
    }

    // Обновляем хеш в URL
    updateHashParam(sectionName);
  }

  // Функция для обновления хеш-параметра
  function updateHashParam(sectionName) {
    // Проверяем, не совпадает ли новый хеш с текущим
    if (window.location.hash.substring(1) !== sectionName) {
      window.location.hash = sectionName;
    }
  }

  // Функция для получения параметра из хеша
  function getHashParam() {
    return window.location.hash.substring(1);
  }

  // Проверяем начальный параметр URL
  function initFromHash() {
    const sectionName = getHashParam();

    // Проверяем существование раздела с таким классом
    if (
      sectionName &&
      document.querySelector(`.infrastructure-content-${sectionName}`)
    ) {
      switchContent(sectionName);
    } else {
      // Получаем имя первого раздела из первой кнопки
      const firstButton = document.querySelector(
        ".infrastructure__filter-button"
      );
      if (firstButton) {
        const contentClass = Array.from(firstButton.classList).find((cls) =>
          cls.startsWith("infrastructure-content-")
        );
        if (contentClass) {
          const defaultSection = contentClass.split(
            "infrastructure-content-"
          )[1];
          switchContent(defaultSection);
        }
      }
    }
  }

  // Обработчик кликов для кнопок (ИЗМЕНЕНИЯ ЗДЕСЬ)
  container.addEventListener("click", function (e) {
    const button = e.target.closest(
      ".infrastructure__filter-button, .infrastructure__select-button"
    );

    // Игнорируем ссылки
    if (!button || button.tagName === "A") return;

    const contentClass = Array.from(button.classList).find((cls) =>
      cls.startsWith("infrastructure-content-")
    );

    if (contentClass) {
      const sectionName = contentClass.split("infrastructure-content-")[1];
      switchContent(sectionName);

      // Закрываем выпадающий список после выбора пункта
      const selectControl = document.querySelector(
        ".infrastructure__select-control"
      );
      if (selectControl) {
        selectControl.classList.remove("infrastructure__select-control--open");
      }
    }
  });

  // Обработчики для мобильного выпадающего списка
  const selectValue = document.querySelector(".infrastructure__select-value");
  if (selectValue) {
    selectValue.addEventListener("click", function (e) {
      e.stopPropagation();
      this.closest(".infrastructure__select-control").classList.toggle(
        "infrastructure__select-control--open"
      );
    });
  }

  // Закрытие выпадающего списка при клике вне его
  document.addEventListener("click", function (e) {
    const selectControl = document.querySelector(
      ".infrastructure__select-control"
    );
    if (selectControl && !selectControl.contains(e.target)) {
      selectControl.classList.remove("infrastructure__select-control--open");
    }
  });

  // Обработка изменений хеша
  window.addEventListener("hashchange", function () {
    const sectionName = getHashParam();
    if (
      sectionName &&
      document.querySelector(`.infrastructure-content-${sectionName}`)
    ) {
      switchContent(sectionName);
    } else {
      // Если хеш пустой или невалидный, показываем первый раздел
      const firstButton = document.querySelector(
        ".infrastructure__filter-button"
      );
      if (firstButton) {
        const contentClass = Array.from(firstButton.classList).find((cls) =>
          cls.startsWith("infrastructure-content-")
        );
        if (contentClass) {
          const defaultSection = contentClass.split(
            "infrastructure-content-"
          )[1];
          switchContent(defaultSection);
        }
      }
    }
  });

  // Инициализация из хеша
  initFromHash();
});

document.addEventListener("DOMContentLoaded", function () {
  // Функция для открытия попапа
  function openPopup(index) {
    const popup = document.querySelector(
      `.infrastructure-popup-content-${index}`
    );
    if (popup) {
      popup.classList.add("infrastructure__popup--active");
      document.body.classList.add("no-scroll");
    }
  }

  // Функция для закрытия попапа
  function closePopup(popup) {
    popup.classList.remove("infrastructure__popup--active");
    document.body.classList.remove("no-scroll");
  }

  // Обработчики для кнопок "Подробнее"
  document
    .querySelectorAll('[class^="infrastructure-popup-"]')
    .forEach((button) => {
      const classList = Array.from(button.classList);
      const popupClass = classList.find((cls) =>
        cls.startsWith("infrastructure-popup-")
      );

      if (popupClass) {
        const index = popupClass.split("-").pop();
        button.addEventListener("click", (e) => {
          e.preventDefault();
          openPopup(index);
        });
      }
    });

  // Обработчики для кнопок закрытия
  document.querySelectorAll(".infrastructure__popup").forEach((popup) => {
    const closeBtn = popup.querySelector(".infrastructure__popup-close");
    if (closeBtn) {
      closeBtn.addEventListener("click", () => closePopup(popup));
    }
  });

  // Закрытие по клику вне попапа
  document.querySelectorAll(".infrastructure__popup").forEach((popup) => {
    popup.addEventListener("click", (e) => {
      if (e.target === popup) {
        closePopup(popup);
      }
    });
  });
});
